export default "__VITE_ASSET__B8ynfo9J__"